import { z } from "zod";
import { AccountUserFieldsSchema } from "./AccountUser";
import { UserFieldsSchema } from "./User";

export const MessageFieldsSchema = z.object({
  id: z.number(),
  content: z.string(),
  dateSent: z.string(),
  isSystemMessage: z.boolean(),
  senderName: z.string(),
  senderAccountUser: z.union([AccountUserFieldsSchema, z.any()]),
  senderUser: z.union([UserFieldsSchema, z.any()]),
  thread: z.any(),
});

export const PartialMessageFieldsSchema = MessageFieldsSchema.deepPartial();

export const MessageExtraFieldsSchema = z.object({
  availableTemplates: z.array(z.number()),
  files: z.any(),
  hasBeenRead: z.boolean(),
});

export const PartialMessageExtraFieldsSchema =
  MessageExtraFieldsSchema.deepPartial();

export const MessageSchema = z.intersection(
  MessageFieldsSchema,
  MessageExtraFieldsSchema
);

export type MessageFields = z.infer<typeof MessageFieldsSchema>;
export type PartialMessageFields = z.infer<typeof PartialMessageFieldsSchema>;
export type MessageExtraFields = z.infer<typeof MessageExtraFieldsSchema>;
export type PartialMessageExtraFields = z.infer<
  typeof PartialMessageExtraFieldsSchema
>;

export type Message = z.infer<typeof MessageSchema>;
export type MessagePartial = z.infer<typeof PartialMessageFieldsSchema>;
